import SamsungOrderInvoiceView from './SamsungOrderInvoiceView';
import { samsungOrderActions } from 'src/store/modules/samsungOrderInvoice';

import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';
import { IInitialState } from 'src/store/initialState';
import {
  samsungOrderInvoiceFormSel,
  pageInformationSel
} from 'src/store/modules/samsungOrderInvoice/selectors';

const mapStateToProps = (state: IInitialState) => ({
  samsungOrderInvoiceForm: samsungOrderInvoiceFormSel(state),
  pageInformation: pageInformationSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  searchSamsungOrdersAndInvoices: (request: any, pagination: any) =>
    dispatch(
      samsungOrderActions.searchSamsungOrderInvoices(request, pagination)
    ),
  exportSamsungOrdersAndInvoices: (request: any) =>
    dispatch(samsungOrderActions.exportSamsungOrdersInvoices(request))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(SamsungOrderInvoiceView));
